import { usePermanentRealTimeTypedQuery } from "components";
import { useDealersDashboardListeners } from "modules/DealersDashboard/components/DealersDashboardTable/listeners";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Dealer } from "models";

const compareByName = (a: { name: string }, b: { name: string }) => {
  if (a.name < b.name) return -1;
  if (a.name > b.name) return 1;

  return 0;
};

const sortDealers = (dealers: Dealer[]) =>
  dealers.map(dealer => (dealer.locations ? { ...dealer, locations: dealer.locations.toSorted(compareByName) } : dealer)).sort(compareByName);

export const useDealersQuery = () => {
  const listeners = useDealersDashboardListeners();

  return usePermanentRealTimeTypedQuery({
    queryKey: DealersDashboardQueryKeys.list,
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.dealers,
    select: sortDealers,
    listeners
  });
};
